import { render, staticRenderFns } from "./ThePersonalPromocodeCard.vue?vue&type=template&id=7c39a954&"
import script from "./ThePersonalPromocodeCard.vue?vue&type=script&lang=js&"
export * from "./ThePersonalPromocodeCard.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalPromocodeCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports